import {QuestionBase} from "./question-base";

export class SelectBigBox extends QuestionBase<string> {
  override controlType = 'bigselectbox';
}
